import { addModal } from 'modules/messageSystem/actions/addModal';
import { removeModal } from 'modules/messageSystem/actions/removeModal';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import * as modalCodes from 'modules/messageSystem/constants/modalCodes';
import { appointmentHavePermission } from 'modules/common/selectors/permissions';
import { fetchConversation } from 'modules/conference/actions/fetchConversation';
import { clearConsultationTimer } from 'modules/conference/epics/startConsultationTimer';
import { fetchAppointmentById } from 'modules/queues/Schedule/actions/fetchAppointmentById';
import { dialerTypes, FUTURE_APPOINTMENT_CONSENT_DIALER } from 'modules/common/constants/conversationInitiatorTypes';
import { hierarchyToString, getProvidingUnitHierarchy } from 'modules/appointmentInfo/selectors/currentAppointmentDetails';
import {
  declineConsultation,
  connectToConversation,
} from 'modules/conference/actions/_newConversationActions/conversationLifecircleActions';

import { invokeAppointmentForwardingConsentModal } from '../futureAppointmentConsent';


export const onIncomingCall = ({ conversationId, appointmentId }) => (dispatch, getState) => {
  const state = getState();
  const { localMediaPermission } = state.common.browserMediaPermissions;
  if ([requestsStatuses.failure, requestsStatuses.pending].includes(localMediaPermission)) throw new Error('No local media permission');

  if (/RnUmmanu/.test(navigator.userAgent)) return null;

  dispatch(clearConsultationTimer());

  Promise.resolve()
    .then(() => dispatch(fetchConversation(conversationId)))
    .then(() => dispatch(fetchAppointmentById(appointmentId)))
    .then(({ appointment }) => {
      const canViewConversation = appointmentHavePermission(appointment, { APPOINTMENTS_CONVERSATION: ['read'] });

      if (!canViewConversation) return;

      const { initiator } = getState().conference.currentConversation;
      const isDialer = dialerTypes.includes(initiator);
      const isConsent = initiator === FUTURE_APPOINTMENT_CONSENT_DIALER;
      const healthcareName = hierarchyToString(getProvidingUnitHierarchy(appointment.service.providingUnit));

      return dispatch(
        addModal({
          testId: 'start-consultation-modal',
          typeId: modalCodes.MODAL_START_CONSULTATION,
          preventClosingWhenDismiss: true,
          canAddDuplicate: false,
          isForce: true,
          bodyValues: { isDialer, healthcareName },
          onOk: () => {
            if (isConsent) {
              removeModal('start-consultation-modal');

              return dispatch(invokeAppointmentForwardingConsentModal({
                appointmentId,
                onOk: () => dispatch(connectToConversation(appointmentId, appointment)),
                onCancel: () => dispatch(declineConsultation(appointmentId)),
              }));
            }
            dispatch(connectToConversation(appointmentId, appointment));
          },
          onCancel: () => dispatch(declineConsultation(appointmentId)),
        }),
      );
    });
};


export const onIncomingCallMessage = ({ conversationId, appointmentId }) => (dispatch, getState) => {
  const state = getState();
  const { localMediaPermission } = state.common.browserMediaPermissions;
  if ([requestsStatuses.failure, requestsStatuses.pending].includes(localMediaPermission)) throw new Error('No local media permission');

  dispatch(clearConsultationTimer());

  Promise.resolve()
    .then(() => dispatch(fetchConversation(conversationId)))
    .then(() => dispatch(fetchAppointmentById(appointmentId)))
    .then(({ appointment }) => {
      const canViewConversation = appointmentHavePermission(appointment, { APPOINTMENTS_CONVERSATION: ['read'] });

      if (!canViewConversation) return;

      return dispatch(connectToConversation(appointmentId, appointment));
    });
};
